import React from 'react';
import { Sparkles } from 'lucide-react';
import OnboardingCarousel, { Spotlight } from './OnboardingCarousel';

// Shown once, right after signup/first sign-in, before a household exists.
// Ends by pointing at the Join/Create buttons rather than explaining them —
// the real ones live on the Profile tab.
const WelcomeCarousel = ({ onDone, onSkip }) => {
  const slides = [
    {
      content: (
        <div className="flex flex-col items-center text-center w-full">
          <div className="w-14 h-14 rounded-2xl bg-mint/15 flex items-center justify-center mb-5">
            <Sparkles className="text-mint" size={26} />
          </div>
          <h2 className="font-serif text-2xl text-ink-fg">Chores, split fairly</h2>
          <p className="text-sm text-ink-fg/55 mt-3 leading-relaxed max-w-[260px]">
            Schores tracks who does what — and gives credit for effort, not just for showing up.
          </p>
        </div>
      ),
    },
    {
      content: (
        <div className="flex flex-col items-center text-center w-full">
          <p className="text-[10px] font-mono font-medium text-ink-fg/40 uppercase tracking-widest mb-4">How points work</p>
          <div className="w-full bg-ink-card3 rounded-2xl border border-white/10 p-4 flex items-center justify-between">
            <div className="text-left">
              <p className="font-medium text-ink-fg/90 text-sm">Bathroom deep clean</p>
              <p className="text-[10.5px] font-mono text-ink-fg/40 mt-1">45 min × difficulty 5</p>
            </div>
            <span className="px-2.5 py-1.5 rounded-lg bg-mint/15 text-mint text-[11px] font-mono font-semibold whitespace-nowrap">+45 PTS</span>
          </div>
          <p className="text-sm text-ink-fg/55 mt-4 leading-relaxed max-w-[260px]">
            A five-minute task and a hard Sunday clean both earn exactly what they're worth.
          </p>
        </div>
      ),
    },
    {
      content: (
        <div className="flex flex-col items-center text-center w-full">
          <p className="text-[10px] font-mono font-medium text-ink-fg/40 uppercase tracking-widest mb-5">One thing first</p>
          <Spotlight>
            <span className="px-6 py-3 rounded-xl bg-mint text-ink-shell font-bold text-sm inline-block">Join a household</span>
          </Spotlight>
          <p className="text-sm text-ink-fg/55 mt-5 leading-relaxed max-w-[260px]">
            Everything lives inside a household. Join one with a roommate's invite code, or start your own — it only takes a second.
          </p>
        </div>
      ),
      cta: "Let's set it up",
    },
  ];

  return <OnboardingCarousel slides={slides} onDone={onDone} onSkip={onSkip} />;
};

export default WelcomeCarousel;
